<template>
  <!--水印-->
  <div class="cover-sy-area">
    <div
      v-for="(item,index) in waterColumn"
      :key="index"
      :class="'cover-column '+item.className"
    >
      <p class="sy-data cover-Blink">{{ waterName }}</p>
      <p class="sy-data cover-Blink">{{ waterName }}</p>
      <p class="sy-data cover-Blink">{{ waterName }}</p>
      <p class="sy-data cover-Blink">{{ waterName }}</p>
      <p class="sy-data cover-Blink">{{ waterName }}</p>
      <p class="sy-data cover-Blink">{{ waterName }}</p>
      <p class="sy-data cover-Blink">{{ waterName }}</p>
      <p class="sy-data cover-Blink">{{ waterName }}</p>
    </div>
  </div>
  <!--水印 end-->
</template>
<script>
export default {
    name: 'Watermark',
    data() {
        return {
            screenWidth: document.body.clientWidth,
            userName: '旭辉',
            waterName: ''
        }
    },
    computed: {
        waterColumn() {
            let waterArr = []
            let className
            let columnNum
            if (this.screenWidth >= 1024) {
                columnNum = 8
                className = 'column1024'
            } else if (this.screenWidth >= 635) {
                columnNum = 5
                className = 'column768'
            } else {
                columnNum = 3
                className = 'column375'
            }
            for (let i = 0; i < columnNum; i++) {
                waterArr.push({
                    className: className,
                    columnNum: columnNum
                })
            }
            return waterArr
        },
        getUserName() {
            return this.$store.state.userName
        }
    },
    watch: {
        getUserName(val) {
            console.log('username', val)
            this.syShowName(val)
        }
    },
    mounted() {
        let self = this
        const username = sessionStorage.getItem('userInfo') || ''
        console.log('username', this.username)
        self.syShowName(this.username)
        window.onresize = () => {
            self.screenWidth = document.body.clientWidth
        }
    },
    methods: {
        syShowName(name = '旭辉') {
            // 生成水印
            let time = new Date()
            let ymm =
        time.getFullYear() + '-' + (time.getMonth() + 1) + '-' + time.getDate()
            this.waterName = name + '  ' + ymm
        }
    }
}
</script>
<style lang="scss" scoped>
/*水印开始*/
.cover-sy-area {
  position: fixed;
  text-align: center;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: block;
  z-index: 99999999;
  pointer-events: none;
  overflow: hidden;
  display: flex;
  flex-flow: wrap;

  .cover-column {
    height: 100%;
    display: flex;
    flex-flow: column;
    .sy-data {
      width: 100%;
      height: 15%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .column375 {
    flex: 1 1 32%;
  }
  .column768 {
    flex: 1 1 20%;
  }
  .column1024 {
    flex: 1 1 12.5%;
  }
}
.cover-Blink {
  padding: 2px 1px;
  font-size: 16px;
  color: #ddd;
  //color: #BBB;
  //color: #AAA;
  //color: #999;
  opacity: 0.2;
  white-space: nowrap;
  text-shadow: 1px 0 0 rgba(0, 0, 0, 0.2);
  transform: rotate(-45deg);
  -ms-transform: rotate(-45deg);
  -moz-transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
  -o-transform: rotate(-45deg);
}
/*水印end*/
</style>

